import { useEffect, useState } from 'react';

const weatherCodeMap = {
  0: '☀️ Ciel dégagé',
  1: '🌤️ Principalement dégagé',
  2: '🌥️ Partiellement nuageux',
  3: '☁️ Couvert',
  45: '🌫️ Brouillard',
  48: '🥶 Brouillard givrant',
  51: '🌂 Bruine légère',
  53: '☂️ Bruine modérée',
  55: '☔ Bruine dense',
  61: '☂️ Pluie légère',
  63: '☔ Pluie modérée',
  65: '🌧️ Pluie forte',
  71: '🌨️ Chute de neige légère',
  73: '🌨️ Chute de neige modérée',
  75: '🌨️ Chute de neige intense',
  95: '🌩️ Orage',
  96: '🌩️ Orage avec grêle',
  99: '⛈️ Orage avec forte grêle'
};

const weatherCodeToText = (code) => weatherCodeMap[code] || 'Inconnu';

const useWeather = (latitude = 47.21, longitude = -1.68) => {
  const [weather, setWeather] = useState({
    temperature: null,
    description: '',
    min: null,
    max: null,
    lastUpdate: null
  });

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true&daily=temperature_2m_max,temperature_2m_min&timezone=auto`;
        const response = await fetch(url);
        const data = await response.json();
        setWeather({
          temperature: Math.round(data.current_weather.temperature),
          description: weatherCodeToText(data.current_weather.weathercode),
          min: Math.round(data.daily.temperature_2m_min[0]),
          max: Math.round(data.daily.temperature_2m_max[0]),
          lastUpdate: new Date(),
        });
      } catch (error) {
        console.error('Erreur lors de la récupération de la météo', error);
      }
    };

    fetchWeather();
  }, [latitude, longitude]);

  return weather;
};

export default useWeather;
